module.exports = __webpack_public_path__ + "static/media/user.a0b2f0b7.svg";